/**
 * File lines formatting helpers for debug panel
 */

/**
 * Normalize a file path to match the project root relative format (e.g. app/..., components/...)
 */
export function normalizeFilePath(rawPath) {
  if (!rawPath) return "";
  let p = String(rawPath).replace(/\\/g, "/");
  p = p.replace(/^\.?\//, "");
  const match = p.match(
    /(app|components|hooks|lib|providers|contexts|modules)\/.+$/,
  );
  if (match) return match[0];
  return p;
}

/**
 * Color class for line count based on architectural thresholds:
 * - > 500 lines: Red (Exceeds 500-line threshold / refactoring candidate)
 * - > 300 lines: Amber (Warning threshold approaching limit)
 * - <= 300 lines: Subtle muted foreground
 */
export function getLineCountColor(lines) {
  if (lines > 500) return "text-rose-500 dark:text-rose-400";
  if (lines > 300) return "text-amber-500 dark:text-amber-400";
  return "text-muted-foreground/70";
}
